
/* eslint-disable */
// @ts-nocheck
// @ts-ignore

import * as srvoption from './srvoption.proto';
import * as im_common from './im_common.proto';
import * as user_common from './user_common.proto';
import * as group_comm from './group_comm.proto';
import * as common from './common.proto';
import * as topic_post_common from './topic_post_common.proto';


export interface GetTopicGuideProgressReq {
  channelId: string;
}

export interface GetTopicGuideProgressRsp {
  ret: number;
  msg: string;
  /** 是否要展示普通成员新手引导 */
  isNormalShow: boolean;
  /** 是否要展示群主管理员新手引导 */
  isAdminShow: boolean;
  toast: string;
}

export interface SetTopicGuideProgressReq {
  /** 已展示的新手引导是否为管理员新手引导 */
  isAdminGuide: boolean;
}

export interface SetTopicGuideProgressRsp {
  ret: number;
  msg: string;
}

export const enum UpdateTopicType {
  UpdateTopicTypeUnknown = 0,
  UpdateTopicTypeNoExpire = 1,
}

export interface UpdateTopicParam {
  topicId: string;
  type: UpdateTopicType;
}

export interface UpdateTopicReq {
  channelId: string;
  updateTopicParams: Array<UpdateTopicParam>;
}

export interface UpdateTopicResult {
  topicId: string;
  ret: number;
  msg: string;
}

export interface UpdateTopicRsp {
  ret: number;
  msg: string;
  resultList: Array<UpdateTopicResult>;
}

export const enum TopicStatus {
  TopicStatusUnknown = 0,
  TopicStatusNormal = 1,
  TopicStatusDeleted = 2,
  TopicStatusToCreate = 3,
}

export interface DeleteTopicReq {
  channelId: string;
  topicId: Array<string>;
}

export interface DeleteTopicResult {
  topicId: string;
  ret: number;
  msg: string;
}

export interface DeleteTopicRsp {
  ret: number;
  msg: string;
  resultList: Array<DeleteTopicResult>;
}

export interface TopicInfo {
  /** 话题ID */
  topicId: string;
  /** 话题名称 */
  topicName: string;
  /** 话题参与数(参与话题的聊天数量) */
  joinCnt: string;
  /** 话题正文 */
  content: string;
  /** 话题图片 */
  picUrls: Array<string>;
  /** 创建时间戳 */
  createUts: string;
  /** 发布时间戳 */
  releaseUts: string;
  /** 过期时间戳 */
  expireUts: string;
  /** 话题所属频道ID */
  cid: string;
  /** 话题所属群组ID */
  gid: string;
  /** 话题创建者ID */
  creatorUid: string;
}

export interface GetChannelTopicItem {
  /** 频道ID */
  channelId: string;
  /** 话题详情 */
  topicInfo: TopicInfo;
  /** 过期描述,群主/管理员展示 */
  expireDesc: string;
  /** 是否过期 */
  isExpire: boolean;
  /** 参与话题的消息 */
  msg: Array<im_common.Msg>;
  /** 参与话题的用户信息 */
  userInfos: Record<string, user_common.UserInfoBase>;
  /** 群组ID */
  gid: string;
  /** 话题创建者信息 */
  creatorInfo: user_common.UserInfoBase;
  /** 频道名称 */
  chanName: string;
  /** 新版参与话题的消息 */
  topicMsgs: Array<topic_post_common.TopicMsg>;
}

export interface GetChannelTopicListReq {
  channelId: string;
  page: number;
  pageSize: number;
  /** 数量不足是否需要同群组内其他频道的数据 */
  needRecommend: boolean;
}

export interface GetChannelTopicListRsp {
  ret: number;
  msg: string;
  /** 来自本频道的话题列表 */
  topicList: Array<GetChannelTopicItem>;
  nextPage: number;
  pageSize: number;
  /** 频道ID和频道基础信息的映射 */
  channelInfos: Record<string, group_comm.ChannelBaseInfo>;
  isEnd: boolean;
  /** 来自其他频道的话题列表 */
  recommendTopicList: Array<GetChannelTopicItem>;
  /** 本次返回的话题列表中的话题总数 */
  topicTotalNum: string;
  /** 本频道的话题总数 */
  thisChannelTopicNum: string;
}

export interface GetGroupTopicListReq {
  /** 群id */
  gid: string;
  /** 页码 */
  page: number;
  /** 页大小 */
  pageSize: number;
  /** 是否需要与我相关，默认是拉取全部 */
  needRelatedMe: boolean;
}

export interface GetGroupTopicListRsp {
  /** 返回码 */
  ret: number;
  /** 返回短语 */
  msg: string;
  /** 话题列表 */
  topicList: Array<GetChannelTopicItem>;
  /** 拉取下一页的时候传给请求包的page字段 */
  nextPage: number;
  /** 结束标识 */
  isEnd: boolean;
  /** 频道ID和频道基础信息的映射 */
  channelInfos: Record<string, group_comm.ChannelBaseInfo>;
}

export interface GetGroupTopicListSimpleReq {
  /** 群id */
  gid: string;
  /** 页码 */
  page: number;
  /** 页大小 */
  pageSize: number;
}

export interface GetGroupTopicListSimpleRsp {
  /** 返回码 */
  ret: number;
  /** 返回短语 */
  msg: string;
  /** 话题列表 */
  topicList: Array<GetChannelTopicItem>;
  /** 拉取下一页的时候传给请求包的page字段 */
  nextPage: number;
  /** 结束标识 */
  isEnd: boolean;
}

export const enum MsgBindTopicType {
  MsgBindTopicTypeUnknown = 0,
  MsgBindTopicTypeSendTopicMsg = 1,
  MsgBindTopicTypeManual = 2,
}

export interface MsgBindTopicReq {
  topicId: string;
  channelId: string;
  msgSeqList: Array<string>;
}

export interface MsgTopicItem {
  /** 消息seq */
  msgSeq: string;
  /** 话题id */
  topicId: Array<string>;
  /** 消息seq的发送时间 */
  msgTime: string;
  /** 话题消息的等级 */
  msgLevel: number;
}

export interface MsgBindTopicInnerReq {
  channelId: string;
  itemList: Array<MsgTopicItem>;
  type: MsgBindTopicType;
  platform: common.Platform;
}

export interface MsgBindTopicRsp {
  ret: number;
  msg: string;
  /** 在210009错误码情况下会返回已绑定的msgseq及对应话题 */
  failedItemList: Array<MsgTopicItem>;
}

export interface MsgUnbindTopicReq {
  channelId: string;
  itemList: Array<MsgTopicItem>;
}

export interface MsgUnbindTopicRsp {
  ret: number;
  msg: string;
}

export const enum GetTopicMsgsSortType {
  GetTopicMsgsSortTypeAsc = 0,
  GetTopicMsgsSortTypeDesc = 1,
}

export interface GetTopicMsgsReq {
  topicId: string;
  /** 首次可不传 */
  msgSeq: string;
  size: number;
  sortType: GetTopicMsgsSortType;
}

export interface GetTopicMsgsRsp {
  ret: number;
  msg: string;
  nextMsgSeq: string;
  size: number;
  msgList: Array<im_common.Msg>;
  isEnd: boolean;
  userInfos: Record<string, user_common.UserInfoBase>;
}

export interface GetChannelMsgTopicInfoReq {
  channelId: string;
  msgSeq: string;
  size: number;
}

export interface GetChannelMsgTopicInfoItem {
  topicInfo: Array<TopicInfo>;
  msgSeq: string;
}

export interface GetChannelMsgTopicInfoRsp {
  ret: number;
  msg: string;
  nextMsgSeq: string;
  size: number;
  itemList: Array<GetChannelMsgTopicInfoItem>;
}

export interface GetChannelMsgTopicInfoByMsgSeqReq {
  channelId: string;
  msgSeqList: Array<string>;
}

export interface TopicIDList {
  topicIdList: Array<string>;
}

export interface GetChannelMsgTopicInfoByMsgSeqItem {
  /** 话题基础数据 */
  topicInfo: TopicInfo;
  /** 是否已过期 */
  isExpire: boolean;
  /** 是否被删除 */
  isDelete: boolean;
}

export interface GetChannelMsgTopicInfoByMsgSeqRsp {
  ret: number;
  msg: string;
  msgSeqTopicIds: Record<string, TopicIDList>;
  topicInfos: Record<string, TopicInfo>;
  topicInfosV2: Record<string, GetChannelMsgTopicInfoByMsgSeqItem>;
}

export interface GetTopicShowLimitReq {
  channelId: string;
}

export const enum TopicShowPopUpType {
  TopicShowPopUpTypeUnknown = 0,
  TopicShowPopUpTypeActiveUser = 1,
  TopicShowPopUpTypeInActiveUser = 2,
}

export interface GetTopicShowLimitRsp {
  ret: number;
  msg: string;
  isShow: boolean;
  showDesc: string;
  showTopic: TopicInfo;
  /** 弹窗类型(见TopicShowPopUpType) */
  popUpType: number;
}

export interface SetTopicShowLimitReq {
  channelId: string;
}

export interface SetTopicShowLimitRsp {
  ret: number;
  msg: string;
}

export const enum MsgBindTopicStatus {
  MsgBindTopicStatusUnknown = 0,
  MsgBindTopicStatusBind = 1,
  MsgBindTopicStatusUnbind = 2,
}

export interface TopicES {
  /** 群id */
  groupId: string;
  /** 频道id */
  channelId: string;
  /** 过期时间 */
  expireTs: string;
  /** 创建时间 */
  createTs: string;
  /** 更新时间 */
  updateTs: string;
  /** 热度分数 */
  hotScore: number;
  /** 排序用分数 */
  sortScore: number;
  /** 总参与消息数 */
  totalJoinCnt: string;
  /** 总参与数更新时间 */
  totalJoinCntUpdateTs: string;
  /** 话题状态(见TopicStatus) */
  status: number;
  /** 话题ID(这个字段需要拉出来自己补上) */
  topicId: string;
  /** 创建者UID */
  creator: string;
  /** 话题名称 */
  topicName: string;
  /** 话题正文 */
  content: string;
  /** 图片列表 */
  picUrls: Array<string>;
  /** 发布时间戳 */
  releaseTs: string;
}

export interface UserTopicActionES {
  /** 群id */
  groupId: string;
  /** 群id */
  channelId: string;
  /** 用户id */
  uid: string;
  /** 操作用户id */
  opUid: string;
  /** 消息序号 */
  msgSeq: string;
  /** 操作时间 */
  opTs: string;
  /** 绑定状态(见MsgBindTopicStatus) */
  status: number;
  /** 话题id */
  topicId: string;
  /** 消息发送时间 */
  msgSendTs: string;
  /** 话题消息等级 */
  topicMsgLevel: number;
}

export interface TopicMsgSeqProgress {
  /** 最新操作时间 */
  lastOpTs: string;
}

export const enum TopicConsumerMsgType {
  TopicConsumerMsgTypeUnknown = 0,
  TopicConsumerMsgTypeTotalJoinCnt = 1,
  TopicConsumerMsgTypeMsgSeqProgress = 2,
  TopicConsumerMsgTypeScore = 3,
  TopicConsumerMsgTypeCreateTopic = 4,
  TopicConsumerMsgTypeCreateTopicAndBindMsg = 5,
  TopicConsumerMsgTypeUpdateTopicStatusToCreate = 6,
}

export interface TopicConsumerMsg {
  /** 消费类型 */
  type: TopicConsumerMsgType;
  /** 话题id */
  topicId: string;
  /** 频道id */
  channelId: string;
  /** 触发时间 */
  ts: string;
  /** 话题名 */
  topicName: string;
  /** 参与数 */
  joinCnt: string;
  /** 操作者 */
  operatorUid: string;
  /** 重试次数 */
  retryCnt: number;
  /** 话题内容 */
  topicCont: string;
  /** 话题图片 */
  picUrls: Array<string>;
}

export interface TopicMsgSeqMemberStorage {
  /** 消息seq */
  msgSeq: string;
  /** 话题信息列表 */
  topicInfoList: Array<TopicInfo>;
}

export interface GetTopicStorageReq {
  /** 话题id列表 */
  topicIdList: Array<string>;
}

export interface GetTopicStorageRsp {
  /** 返回值 */
  ret: number;
  /** 返回信息 */
  msg: string;
  /** 话题信息 */
  topicInfos: Record<string, TopicES>;
}

export interface SetTopicRecentStorageReq {
  /** 频道id */
  cid: string;
  /** 话题id */
  topicId: string;
}

export interface SetTopicRecentStorageRsp {
  /** 返回码 */
  ret: number;
  /** 返回信息 */
  msg: string;
}

export interface GetGroupTopicBubbleShowReq {
  /** 群id列表 */
  groupIds: Array<string>;
}

export interface ChannelTopicBubbleShowItem {
  /** 频道id */
  channelId: string;
}

export interface GroupTopicBubbleShowInfo {
  /** 群id */
  groupId: string;
  /** 频道气泡展示信息 */
  channelShowInfos: Record<string, ChannelTopicBubbleShowItem>;
}

export interface GetGroupTopicBubbleShowRsp {
  /** 返回码 */
  ret: number;
  /** 返回信息 */
  msg: string;
  /** 群组话题气泡展示信息 */
  showInfos: Record<string, GroupTopicBubbleShowInfo>;
}

export interface GetTopicExtendInfoReq {
  /** 话题id */
  topicId: string;
  /** 是否需要群组和频道基础信息 */
  needGroupChannelBaseInfo: boolean;
}

export interface GetTopicExtendInfoRsp {
  /** 返回值 */
  ret: number;
  /** 返回信息 */
  msg: string;
  /** 群组信息 */
  groupInfo: group_comm.GroupInfo;
  /** 频道信息 */
  channelBaseInfo: group_comm.ChannelBaseInfo;
  /** 话题信息 */
  topicInfo: TopicES;
  /** 话题收藏信息 */
  collectorMsgSeq: string;
  /** 话题是否过期 */
  isExpire: boolean;
  /** 群组是否被删除 */
  isGroupDelete: boolean;
  /** 频道是否被删除 */
  isChannelDelete: boolean;
  /** 话题是否被删除 */
  isTopicDelete: boolean;
}

export interface CreateTopicAndBindMsgReq {
  /** 频道id */
  channelId: string;
  /** 话题名称 */
  topicName: string;
  /** msgseq列表 */
  msgSeqList: Array<string>;
}

export interface CreateTopicAndBindMsgRsp {
  /** 返回值 */
  ret: number;
  /** 返回信息 */
  msg: string;
  /** 话题id */
  topicId: string;
  /** 在210009错误码情况下会返回已绑定的msgseq及对应话题 */
  failedItemList: Array<MsgTopicItem>;
}

export interface TopicIDMsgSeqStorage {
  /** 消息seq */
  msgSeq: string;
  /** 话题消息 */
  topicMsg: im_common.Msg;
}

export interface GetTopicInfoItem {
  /** 话题基础数据 */
  topicInfo: TopicInfo;
  /** 群id */
  groupId: string;
  /** 频道id */
  channelId: string;
  /** 是否需要展示参与按钮 */
  needShowJoinButton: boolean;
}

export interface GetTopicInfoReq {
  /** 话题id列表 */
  topicIdList: Array<string>;
}

export interface GetTopicInfoRsp {
  ret: number;
  msg: string;
  /** 话题数据 */
  topicInfos: Record<string, GetTopicInfoItem>;
}

export interface DeleteGroupTopicReq {
  /** 群id */
  groupId: string;
  /** 频道id */
  channelId: string;
}

export interface DeleteGroupTopicRsp {
  ret: number;
  msg: string;
}

export interface PreprocessTopicNameReq {
  topicName: string;
  channelId: string;
}

export interface PreprocessTopicNameRsp {
  ret: number;
  msg: string;
}

export interface GetRecommendTopicReq {
  channelId: string;
}

export interface GetRecommendTopicRsp {
  ret: number;
  msg: string;
  topicInfos: Array<TopicInfo>;
}

export interface SetRecommendTopicCloseReq {
  channelId: string;
}

export interface SetRecommendTopicCloseRsp {
  ret: number;
  msg: string;
}

export interface ClearTopicShowLimitRecordReq {
  /** 用户id */
  uid: string;
}

export interface ClearTopicShowLimitRecordRsp {
  ret: number;
  msg: string;
}

export interface ClearTopicGuideRecordReq {
  /** 用户id */
  uid: string;
}

export interface ClearTopicGuideRecordRsp {
  ret: number;
  msg: string;
}

export interface ClearRecommendTopicCloseReq {

}

export interface ClearRecommendTopicCloseRsp {
  ret: number;
  msg: string;
}
